import { ConnectUserType } from '../constants';

/**
 * ユーザーによって利用規約・利用要領のどちらかを返却する
 * @param userType ユーザータイプ
 * @returns 管理会社：「利用要領」
 */
export const getTermTitleText = (userType: ConnectUserType) => {
  switch (userType) {
    case ConnectUserType.Estate:
      return '利用要領';
    default:
      return '利用規約';
  }
};
